export const handleCopyClick = (event: React.MouseEvent, text: string, enqueueSnackbar?: any) => {
  event.stopPropagation();
  navigator.clipboard.writeText(text);
  if (enqueueSnackbar) {
    enqueueSnackbar('Copied to clipboard', {
      autoHideDuration: 1000,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
      },
    });
  }
};
